<template>
  <div class="card card-user">
    <div class="card-header">
      <h4 class="title" style="text-align: center;">User Details</h4>
    </div>
    <div class="card-content">
      <div class="author">
        <v-gravatar class="avatar border-white" v-if="!!authDetails.userAuth.email" :email="authDetails.userAuth.email" :size="34" alt="..." />
        <form>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>First Name</label>
                <input type="text"
                      name="firstName"
                      class="form-control border-input"
                      placeholder="First Name"
                      v-model="authDetails.user.data.firstName"
                      v-validate="modelValidations.firstName">
                <small class="text-danger" v-show="firstName.invalid">
                  {{ getError('firstName') }}
                </small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Last Name</label>
                <input type="text"
                      name="lastName"
                      class="form-control border-input"
                      placeholder="Last Name"
                      v-model="authDetails.user.data.lastName"
                      v-validate="modelValidations.lastName">
                <small class="text-danger" v-show="lastName.invalid">
                  {{ getError('lastName') }}
                </small>
              </div>
            </div>
          </div>
          
          <div class="text-center">
            <button v-if="!loading" type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="submit">
              Save
            </button>
            <button v-if="loading" type="submit" class="btn btn-info btn-fill btn-wd" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Save
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
        <br><br>
        <small>
          {{ authDetails.userAuth.email }}<br><button id="update-email" @click.prevent="updateEmail()" class="btn btn-sm">change</button><br><br>
          {{ authDetails.userAuth.phoneNumber }}<br><button id="update-phone" class="btn btn-sm">change</button>
        </small>
      </div>
    </div>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import swal from 'sweetalert2'
  import { EventBus } from '@/eventBus'
  import {mapFields} from 'vee-validate'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'

  export default {
    props: {
      authDetails: {
        type: Object,
        required: true
      }
    },
    mixins: [toolboxMixin],
    computed: {
      ...mapFields(['firstName',
        'lastName'])
    },
    data () {
      return {
        modelValidations: {
          firstName: {
            required: true
          },
          lastName: {
            required: true
          }
        },
        loading: false,
        details: [
          {
            title: '...',
            subTitle: 'Protected Products'
          },
          {
            title: '...',
            subTitle: 'Validated Products'
          },
          {
            title: '...',
            subTitle: 'Registered Products'
          }
        ],
        recaptcha: {
          verifier: null,
          confirmationResult: null,
          widgetId: null
        }
      }
    },
    methods: {
      async init () {
        console.log('authDetails')
        console.log(this.authDetails)
        this.details[0].title = this.authDetails.account.data.qtyCertified
        this.details[1].title = this.authDetails.account.data.qtyValidated
        this.details[2].title = this.authDetails.account.data.qtyRegistrations
        this.setupRecaptcha()
      },
      setupRecaptcha () {
        // Start Firebase invisible reCAPTCHA verifier
        this.recaptcha.verifier = new firebase.auth.RecaptchaVerifier('update-phone', {
          size: 'invisible',
          callback: response => {
            // reCAPTCHA solved, allow to proceed
            console.log('solved ' + response)
            this.updatePhone()
          },
          error: () => {
            swal.fire({
              title: 'Error',
              text: 'There was a problem validating captcha',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
          }
        })

        this.recaptcha.verifier.render().then((widgetId) => {
          this.recaptcha.widgetId = widgetId
        })
      },
      resetRecaptcha () {
        window.grecaptcha.reset(this.recaptcha.widgetId)
      },
      getClasses (index) {
        const remainder = index % 3
        if (remainder === 0) {
          return 'col-md-3 col-md-offset-1'
        } else if (remainder === 2) {
          return 'col-md-4'
        } else {
          return 'col-md-3'
        }
      },
      updateEmail () {
        swal.fire({
          title: 'New Email Address',
          text: 'Please provide your new email address below. Note that a notification of the change will be sent to the current address.',
          type: 'question',
          input: 'text',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false,
          inputPlaceholder: 'user@domain.com'
        })
        .then(newEmailInputResult => {
          return firebase.auth().currentUser.updateEmail(newEmailInputResult.value)
        })
        .then(() => {
          console.log('emitting')
          EventBus.$emit('auth-refreshed')
          swal.fire({
            title: `Saved`,
            text: 'Your email address was updated.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          })
        })
        .catch(error => {
          console.log(error)
          if (error.code === 'auth/requires-recent-login') {
            swal.fire({
              title: 'Error',
              text: 'Sorry, changing your email requires recently logging in. Please log out and log in then try again.',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
          } else {
            swal.fire({
              title: 'Error',
              text: 'There was a problem updating your email address. Please try again and contact support if it persists. Details: ' + error.message,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
          }
        })
      },
      updatePhone () {
        swal.fire({
          title: 'New Mobile Number',
          text: 'Please provide the new mobile number:',
          type: 'question',
          input: 'text',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false,
          inputPlaceholder: '5556667777'
        })
        .then(newPhoneInputResult => {
          let newPhone = '+1' + newPhoneInputResult.value
          var provider = new firebase.auth.PhoneAuthProvider()
          return provider.verifyPhoneNumber(newPhone, this.recaptcha.verifier)
        })
        .then(async verificationId => {
          let inputResult = await swal.fire({
            title: 'SMS Verification',
            text: 'An authentication code was sent to your new phone number. Please provide it below:',
            type: 'question',
            input: 'text',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false,
            inputPlaceholder: 'SMS Auth Code'
          })
          return {
            verificationId: verificationId,
            phone: inputResult.value
          }
        })
        .then(result => {
          console.log('verificationId')
          console.log(result)
          return firebase.auth.PhoneAuthProvider.credential(result.verificationId, result.phone)
        })
        .then(phoneCredential => {
          return firebase.auth().currentUser.updatePhoneNumber(phoneCredential)
        })
        .then(() => {
          console.log('emitting')
          EventBus.$emit('auth-refreshed')
          swal.fire({
            title: `Saved`,
            text: 'Your phone number was updated.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          })
        })
        .catch(error => {
          console.log(error)
          swal.fire({
            title: 'Error',
            text: 'There was a problem updating your phone number. Please try again and contact support if it persists. Details: ' + error.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.resetRecaptcha()
        })
      },
      updateUser () {
        db.collection('users').doc(this.authDetails.user.id).update(this.authDetails.user.data).then(() => {
          this.showNotify('User information saved.', 'success', 'Success')
          this.loading = false
        })
        .catch(error => {
          this.showNotify(error, 'danger', 'Failed')
          this.loading = false
        })
      },
      submit () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.updateUser()
          } else {
            this.loading = false
          }
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    async mounted () {
      this.init()
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/partials/UserCard.vue